/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

var languages = {
  de: 'de',
  en: 'en',
  es: 'es',
  fr: 'fr',
  it: 'it',
  ja: 'ja',
  ko: 'ko',
  pt: 'pt-br',
  'pt-br': 'pt-br',
  'pt-pt': 'pt-br',
  'zh-cn': 'zh-cn',
  'zh-hans': 'zh-cn',
  'zh-sg': 'zh-cn',
  // Simplified Chinese (Singapore)
  'zh-tw': 'zh-tw',
  'zh-hant': 'zh-tw',
  'zh-hant-tw': 'zh-tw',
  'zh-hk': 'zh-tw',
  // Traditional Chinese (Hong Kong)
  'zh-mo': 'zh-tw' // Traditional Chinese (Macao)
};
var getLocale = function getLocale() {
  var acceptString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'en';
  // Simple (known) language codes
  var result = languages[acceptString.toLowerCase()];
  if (!result) {
    // Match <language> followed by :
    //  <;.*> or
    //  <,.*> or
    //  <eol>
    // * Ignore leading whitespace
    // * Ignore whitespace after <language>
    var match = /^\s*(.*?)\s*(;.*$|,.*$|$)/.exec(acceptString);
    if (match) {
      var lang = match[1].toLowerCase();
      result = languages[lang];
      if (!result) {
        var parts = lang.split('-');
        var firstPart = parts[0].toLowerCase();
        var secondPart = parts[1] ? parts[1].toLowerCase() : '';
        result = languages[firstPart];
        if (!result) {
          // Nothing yet? Check if this is a special case for zh-tw
          if (firstPart.indexOf('zh') === 0 && secondPart.indexOf('tw') !== -1) {
            result = 'zh-tw';
          } else if (firstPart.indexOf('zh') === 0) {
            result = 'zh-cn';
          }
        }
      }
    }
  }
  if (!result) {
    result = 'en';
  }
  return result;
};
var documentLanguage = typeof document !== 'undefined' && document.documentElement && document.documentElement.lang || 'en';

export { documentLanguage, getLocale };
